module.exports = __webpack_public_path__ + "img/back.d2e89ae7.svg";